import React from 'react';
import { Text, View, Image, ScrollView } from 'react-native';
import { getImagePath } from '../../utils/services/CommonUtils';
import { AnimatedShimmer, BackgroundShimmer } from './CommonShimmer';
import AppTheme from "../../AppTheme";
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';
import Colors from '../../utils/constants/AppColors';
import { DealShimmer } from './DealShimmer';

export const ChemistDashboardShimmer = (props) => {
    return (
        <ScrollView style={{ width: AppTheme.appWidth }}>

            <View style={[AppStyles.flexRowSpaceBetween,
            { padding: 16 }]}>
                <View>
                    <BackgroundShimmer width={132} height={8} />
                    <BackgroundShimmer width={196} height={8}
                        marginTop={8} />
                </View>
                <BackgroundShimmer width={32} height={32}
                    borderRadius={12} />
            </View>

            <View style={[AppStyles.flexRowStart, AppStyles.borderView, AppStyles.bgWhite, {
                paddingHorizontal: 16, paddingVertical: 12,
                alignSelf: "center", width: AppTheme.appWidth - 32,
                marginBottom: 24
            }]}>
                <Image style={{ marginRight: 16, height: 16, width: 16 }}
                    source={{ uri: getImagePath('/images/icons/search_grey.svg') }} />
                <Text style={[TextStyle.text16,
                { color: AppTheme.color.grey.disable }]}>
                    Search for medicine here...</Text>
            </View>

            <View style={[AppStyles.flexRowSpaceBetween,
            { marginBottom: 44 }]}>
                <BackgroundShimmer height={284}
                    width={(AppTheme.appWidth - 316) / 2}
                    borderTopRightRadius={12}
                    borderBottomRightRadius={12} />
                <AnimatedShimmer width={284} height={284} />
                <BackgroundShimmer height={284}
                    width={(AppTheme.appWidth - 316) / 2}
                    borderTopLeftRadius={12}
                    borderBottomLeftRadius={12} />
            </View>

            <AnimatedShimmer height={76} />

            <Text style={[TextStyle.text16b, AppStyles.mt24, AppStyles.mb16, AppStyles.ml16]}>
                Products Offered</Text>

            <DealShimmer />

        </ScrollView>
    )
}
